import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalController} from 'ionic-angular';
import {DynamicSelectOptions} from './dynamic-select.options';

@Component({
  selector: 'dynamic-select',
  templateUrl: 'dynamic-select.html'
})
export class DynamicSelectComponent {

  @Input() model: any = {};
  @Input() label: any = '';
  @Input() color: any = '';
  @Input() enabled: boolean = true;
  @Input() visible: boolean = false;
  @Input() options: Array<{ label: string, value: any }> = [];
  @Output() selected: EventEmitter<any> = new EventEmitter();

  constructor(private modalCtrl: ModalController) {
  }

  selectOptions() {
    const modal = this.modalCtrl.create(
      DynamicSelectOptions,
      {title: this.label, color: this.color, options: this.options},
      {enableBackdropDismiss: false}
    );

    const handleSelection = (option?: { label: string, value: any }) => {
      if (option) {
        this.model = option;
        this.selected.emit(this.model);
      }
    };

    modal.onDidDismiss(handleSelection);
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/dynamic-select/dynamic-select.ts